import React from 'react';

const SidePanel = ({ handleLogout }) => {
  return (
    <div className="bg-gray-800 text-white w-64 p-4 flex flex-col justify-between">
      <div>
        <h2 className="text-2xl font-bold mb-4">Admin Menu</h2>
        <ul>
          <li className="mb-2">
            <a href="/admin" className="block p-2 rounded hover:bg-gray-700">Forms</a>
          </li>
          <li className="mb-2">
            <a href="/admin/news" className="block p-2 rounded hover:bg-gray-700">News</a>
        </li>
        <li className="mb-2">
          <a href="/admin/events" className="block p-2 rounded hover:bg-gray-700">Events</a>
        </li>
        <li className="mb-2">
          <a href="/admin/landmarks" className="block p-2 rounded hover:bg-gray-700">Landmark Projects</a>
          </li>
<li className="mb-2">
          <a href="/admin/vehicles" className="block p-2 rounded hover:bg-gray-700">Vehicles</a>
          </li>
<li className="mb-2">
          <a href="/admin/machinery" className="block p-2 rounded hover:bg-gray-700">Machinery</a>
          </li>
        </ul>
      </div>
      <button
        onClick={handleLogout}
        className="bg-red-500 text-white font-bold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins"
      >
        Logout
      </button>
    </div>
  );
};

export default SidePanel;
